/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MuDataProcessingJoinersCustomPlaceCrossingDriver
 */
export interface MuDataProcessingJoinersCustomPlaceCrossingDriver {
    /**
     * 
     * @type {number}
     * @memberof MuDataProcessingJoinersCustomPlaceCrossingDriver
     */
    driverId: number;
}

export function MuDataProcessingJoinersCustomPlaceCrossingDriverFromJSON(json: any): MuDataProcessingJoinersCustomPlaceCrossingDriver {
    return MuDataProcessingJoinersCustomPlaceCrossingDriverFromJSONTyped(json, false);
}

export function MuDataProcessingJoinersCustomPlaceCrossingDriverFromJSONTyped(json: any, ignoreDiscriminator: boolean): MuDataProcessingJoinersCustomPlaceCrossingDriver {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'driverId': json['driver_id'],
    };
}

export function MuDataProcessingJoinersCustomPlaceCrossingDriverToJSON(value?: MuDataProcessingJoinersCustomPlaceCrossingDriver | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'driver_id': value.driverId,
    };
}


